var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileCategories(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.55371 0.0732422V4.05735H9.36676V14.0589H15.0599V1.23871L7.55371 0.0732422ZM11.6233 11.3293H10.7268V4.07767H11.6233V11.3293ZM13.6703 12.5647H12.7738V4.07767H13.6703V12.5647Z",
    fill: "#35435E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.12164 9.09831V9.99482H3.01277V11.1902H2.12164V12.0867H3.01277V14.059H0.731445V7.23535H3.01277V9.09831H2.12164Z",
    fill: "#35435E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90918 4.95215V14.0571H8.47154V4.95215H3.90918ZM6.87276 11.7758H5.50796V10.8793H6.87276V11.7758ZM6.87276 9.72877H5.50796V8.83226H6.87276V9.72877ZM6.87276 7.68173H5.50796V6.78522H6.87276V7.68173Z",
    fill: "#35435E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCategories);
export default __webpack_public_path__ + "static/media/profile-categories.0c92d58ca514017810d4c95c7574a7c0.svg";
export { ForwardRef as ReactComponent };